/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：771
 */

var r = require(/* 1175 */"../../../../../../253/2568/2569/2570/2571/1175")
var i = require(/* 1171 */"./1171")
module.exports = function (e) {
  return null != e && i(e.length) && !r(e)
}
